import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-section',
    templateUrl: './dashboard-section.component.html',
    styleUrls: ['./dashboard-section.component.scss'],
    standalone: false
})
export class DashboardSectionComponent {
    @Input() title: string = '';
    @Input() icon: string = 'dashboard';
    @Input() color: string = 'primary';
    @Input() isCollapsible: boolean = false;

    isExpanded: boolean = true;

    constructor() { }

    toggleSection() {
        if (this.isCollapsible) {
            this.isExpanded = !this.isExpanded;
        }
    }
}
